import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/DecodeVin'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class DecodeVinStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "DecodeVinStore",
			variables: true,
		})
	}
}

export async function load_DecodeVin(params) {
  await initClient()

	const store = new DecodeVinStore()

	await store.fetch(params)

	return {
		DecodeVin: store,
	}
}
